import { render, staticRenderFns } from "./xunwen.vue?vue&type=template&id=c411e1e8&scoped=true&"
import script from "./xunwen.vue?vue&type=script&lang=js&"
export * from "./xunwen.vue?vue&type=script&lang=js&"
import style0 from "./xunwen.vue?vue&type=style&index=0&lang=css&"
import style1 from "./xunwen.vue?vue&type=style&index=1&id=c411e1e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c411e1e8",
  null
  
)

export default component.exports